import React from 'react'
import propTypes from 'prop-types'
import {isEmpty} from 'lodash'
import ActionLink, {LINK_TYPE} from 'components/actionLink'

const ActionEmailLink = (props) => {
  const {value, category} = props
  return isEmpty(value)
      ? null
      : <ActionLink
          className={'email'}
          category={category}
          action={'Email Link'}
          label={'Clicked on an email'}
          type={LINK_TYPE.EMAIL}
          href={`mailto:${value}`}
          title={value}/>
}

ActionEmailLink.propTypes = {
  value: propTypes.any,
  category: propTypes.string.isRequired,
}

export default ActionEmailLink
